import { initializeApp } from 'firebase/app';

/**
 * The Firebase app (SPEC-009 PR-9.3, ADR-0005).
 *
 * Shared with habb.me and plant.habb.me (ADR-0003): one project, so one auth
 * tenant, so a habb.me account is already an account here and nobody signs up
 * for Legends. Mirrored from
 * `~/projects/plant.habb.me/src/infrastructure/cloud/firebaseApp.js`, which was
 * itself mirrored from habb.me's.
 *
 * THE WEB CONFIG BELOW IS COMMITTED DELIBERATELY. It is public client
 * configuration: it identifies the project and authorises nothing, and access is
 * controlled by the security rules in `~/projects/pwa/firestore.rules`. CON-001
 * says this in as many words, and says why treating it as a secret is the worse
 * outcome.
 *
 * And the thing this file is most likely to make somebody do wrong: importing
 * Firestore here does NOT give this repository the right to configure it.
 * Legends may not deploy rules, indexes or functions (CON-003) — a bare
 * `firebase deploy` from this repo replaces habb.me's 951-line ruleset with
 * nothing. There is no rules file here on purpose.
 *
 * The auth domain is this product's own hostname: the sign-in popup and the
 * email-link redirect run same-origin, which is the difference between a flow
 * Safari allows and one its third-party-storage rules quietly break. Both
 * hostnames must be listed under Authentication → Authorized domains in the
 * Firebase console.
 */

const LOCAL_DEVELOPMENT_AUTH_DOMAIN = 'habitly-223108.firebaseapp.com';
const LOCAL_DEVELOPMENT_HOSTNAMES = new Set(['', 'localhost', '127.0.0.1', '::1']);
const PRODUCTION_AUTH_DOMAIN = 'legends.habb-me.com';

export function resolveFirebaseAuthDomain(hostname) {
    if (hostname && !LOCAL_DEVELOPMENT_HOSTNAMES.has(hostname)) {
        return PRODUCTION_AUTH_DOMAIN;
    }

    return LOCAL_DEVELOPMENT_AUTH_DOMAIN;
}

function getCurrentHostname() {
    if (typeof window === 'undefined' || !window.location || !window.location.hostname) {
        return '';
    }

    return window.location.hostname;
}

const firebaseConfig = {
    apiKey: 'AIzaSyCkot9ZC2_OWFmA37bDam3kBflLDb3hXwY',
    authDomain: resolveFirebaseAuthDomain(getCurrentHostname()),
    projectId: 'habitly-223108',
    storageBucket: 'habitly-223108.appspot.com',
    messagingSenderId: '1068183695954',
    // habb.me's web-app registration, until a legends-habb-me web app is
    // registered in the console — the same position plant.habb.me is in, and
    // for the same reason. Auth and Firestore behave identically either way,
    // because the appId scopes analytics attribution and this product has none
    // (ADR-0004 records that absence as deliberate).
    appId: '1:1068183695954:web:6567347443cdbe0318a58b',
};

export const firebaseApp = initializeApp(firebaseConfig);
